import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);

// User
export const getUserProfile = () => api.get('/users/me');
export const updateUserProfile = (data) => api.put('/users/me', data);

// Points
export const getPointsHistory = () => api.get('/points/history');
export const simulatePurchase = (purchaseAmount) => api.post('/points/purchase', { purchaseAmount });

// Rewards
export const getRewards = () => api.get('/rewards');
export const redeemReward = (rewardId) => api.post('/rewards/redeem', { rewardId });
export const getMyRedemptions = () => api.get('/rewards/my-redemptions');

// Tiers
export const getTiers = () => api.get('/tiers');
export const getMyTier = () => api.get('/tiers/my-tier');

// Promotions
export const getActivePromotions = () => api.get('/promotions/active');

// Wallet / Membership Card
export const getMembershipCard = () => api.get('/wallet/membership-card');

// Analytics (Admin)
export const getAnalyticsDashboard = () => api.get('/analytics/dashboard');
export const getAllUsers = () => api.get('/analytics/users');

export default api;
